<template>
  <div v-loading.fullscreen.lock="loading">
    <el-row :gutter="16">
      <el-col :span="12">
        <el-card class="input-card">
          <div slot="header" class="header">
            <div class="title">召回测试</div>
            <div v-if="dataset.id">
              <el-button icon="el-icon-s-grid" @click="handleSearchModeConfig">{{searchMode}}</el-button>
              <el-button type="primary" @click="handleRetrieval">测试</el-button>
            </div>
          </div>
          <div>
            <div class="dataset-name"><b><i class="el-icon-folder mr-4" />知识库：</b>{{ dataset.name }}</div>
            <el-input type="textarea" v-model="query" :rows="20" placeholder="根据给定的查询文本测试知识的召回效果。" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card" v-if="retrievalResult !== null">
          <div slot="header" class="header">
            <div class="title">召回结果</div>
          </div>
          <div class="text-wrap" v-if="retrievalLoading || !retrievalResult.length">
            <template v-if="retrievalLoading">
              <i class="el-icon-loading mr-4" />正在执行...
            </template>
            <template v-else>
              无任何召回结果
            </template>
          </div>
          <template v-if="!retrievalLoading">
            <template v-if="retrievalResult.length">
              <div v-for="(item, idx) in retrievalResult" :key="idx"  @click="openDetailDlg(item)" class="result-card-wrap">
                <el-card  class="box-card result-card">
                  <retrieval-card :item="item" :fold="true" />
                  <div class="card-bottom">
                    <div class="doc-name">
                      <i class="el-icon-document mr-4" />
                      <span>{{ item.title || '-' }}</span>
                      <i class="el-icon-download download-btn" v-if="get(item, 'metadata.source')" @click="download($event, get(item, 'metadata.source'))" />
                    </div>
                    <div class="open-btn" @click="openDetailDlg(item)">
                      打开<i class="el-icon-top-right ml-2" v-if="get(item, 'metadata.source')" />
                    </div>
                  </div>
                </el-card>
              </div>
            </template>
          </template>
        </el-card>
      </el-col>
    </el-row>
    <search-mode-config-drawer :dataset="dataset" :visible="visible" @close="visible=false" @resetSearchMode="resetSearchMode" />
    <el-dialog title="段落详情" :visible.sync="detailVisible" class="detail-dialog" :close-on-click-modal="false">
      <div class="dialog-content-wrap">
        <retrieval-card :item="detailItem" :fold="false" />
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import SearchModeConfigDrawer from './components/searchModeConfigDrawer.vue';
import {get, round} from 'lodash';
import {cosDownload} from '@/utils/cosDownload';
import RetrievalCard from './components/retrievalCard.vue';
import { SEARCH_MODE } from '@/utils/constant';
const searchModeConfigKeys = ['top_k', 'score_threshold', 'reranking_mode', 'reranking_model', 'reranking_enable', 'weights', 'search_mode'];
function parseJson(str, defaultValue) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultValue;
  }
}
export default {
  data() {
    return {
      query: '',
      loading: false,
      retrievalLoading: false,
      visiable: false,
      dataset: {},
      visible: false,
      retrievalResult: null,
      detailVisible: false,
      detailItem: {},
    };
  },
  components:{
    SearchModeConfigDrawer,
    RetrievalCard,
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    searchMode() {
      return SEARCH_MODE[this.dataset?.search_mode];
    }
  },
  async created() {
    await this.getDataset();
  },
  methods: {
    get,
    round,
    async getDataset() {
      try {
        this.dataset = {};
        const { dataset } = await this.$request({
          url: this.$api.getAgentDataset,
          data: {
            id: this.$route?.query?.dataset_id,
          },
        });
        this.dataset = dataset;
      } catch (err) {
        console.log(err);
        this.dataset = {};
      }
    },
    handleSearchModeConfig() {
      this.visible = true;
    },
    resetSearchMode(searchMode) {
      for(const k of Object.keys(searchMode)) {
        this.$set(this.dataset, k, searchMode[k]);
      }
    },
    async handleRetrieval() {
      if(!this.query.trim()) {
        this.$message.warning('请输入查询文本');
        return;
      }
      this.retrievalResult = [];
      this.retrievalLoading = true;
      const searchModoConfig = {};
      searchModeConfigKeys.forEach(key => {
        if(['weights', 'reranking_model'].includes(key)) {
          searchModoConfig[key] = parseJson(this.dataset[key]);
        } else {
          searchModoConfig[key] = this.dataset[key];
        }
      });
      try {
        const { documents } = await this.$request({
          showLoading: false,
          url: this.$api.retrievalKnowledge,
          data: {
            query: this.query,
            datasets: [this.$route?.query?.dataset_id],
            ...searchModoConfig,
          },
        });
        this.retrievalResult = documents || [];
        this.retrievalLoading = false;
      } catch(e) {
        console.error(e);
        this.retrievalLoading = false;
      }
    },
    async download(e, url) {
      e.stopPropagation();
      try {
        await cosDownload(url, { isPrivate: true });
      } catch(e) {
        console.log(e);
      }
    },
    openDetailDlg(item) {
      this.detailItem = item;
      this.detailVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';
@import '@/styles/element/pagination.scss';
.header {
  display: flex;
  justify-content: space-between;
  height: 24px;
  .title {
    font-size: 16px;
    font-weight: 500;
  }
}
.dataset-name {
  margin-bottom: 8px;
}
.result-card-wrap {
  cursor: pointer;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    .result-card {
      border: 1px solid var(--Border-Accent-Ongoing-default);
      .open-btn {
        color: var(--Text-Brand-default);
      }
    }
  }
  .result-card {
    box-shadow: none;
    border: 1px solid var(--Border-Neutral-line-light);

    ::v-deep {
      .el-card__body {
        padding: 12px;
      }
    }
    .card-bottom {
      border-top: 1px solid #DDD;
      padding-top: 8px;
      display: flex;
      justify-content: space-between;
    }
    .doc-name {
      font-weight: 500;
    }
    .download-btn {
      cursor: pointer;
      color: var(--Icon-Brand-default);
      margin-left: 4px;
    }
  }
}

.text-wrap {
  width: 100%;
  margin: 16px;
  text-align: center;
  color: var(--Text-Neutral-subtle);
  i {
    font-size: 16px;
  }
}
.detail-dialog {
  ::v-deep {
    .el-dialog__body {
      padding: 8px 0 16px 0;
    }
  }
  .dialog-content-wrap {
    max-height: calc(100vh - 200px);
    min-height: 400px;
    overflow: auto;
    padding: 0px 24px;
  }
}

</style>
